import React from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';

export const ContactSection = () => {

  return (
    <section id="contact" className="py-20 px-6 bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <div className="max-w-4xl mx-auto">
        {/* Contact Information */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Get in touch
          </h2>
          <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 inline-block shadow-lg">
            <div className="flex items-center justify-center space-x-3">
              <Mail className="w-6 h-6 text-blue-500" />
              <a 
                href="mailto:therapywithrasika@gmail.com"
                className="text-lg text-gray-700 hover:text-blue-600 transition-colors"
              >
                therapywithrasika@gmail.com
              </a>
            </div>
          </div>
        </div>
        
        {/* Typeform Button */}
        <div className="flex justify-center">
          <a
            href="https://form.typeform.com/to/AWz83UZY"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button 
              className="bg-black hover:bg-gray-800 text-white px-12 py-6 text-xl rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl"
            >
              Try Online Therapy
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};